(function () {
  const playVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const prevSlide = swiper.slides[swiper.previousIndex];
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      const videoActive = activeSlide.querySelector(
        ".image-tagline-slider__slide-video"
      );
      if (videoActive) {
        videoActive.play().catch((error) => {
          console.error("Error playing video:", error);
        });
      }
    }

    if (prevSlide && prevSlide !== activeSlide) {
      const videoPrev = prevSlide.querySelector(
        ".image-tagline-slider__slide-video"
      );
      if (videoPrev) videoPrev.pause();
    }
  };

  const stopVideo = (swiper) => {
    if (!swiper?.enabled) return;
    const activeSlide = swiper.slides[swiper.activeIndex];

    if (activeSlide) {
      const videoActive = activeSlide.querySelector(
        ".image-tagline-slider__slide-video"
      );
      if (videoActive) videoActive.pause();
    }
  };

  const initAutoplayObserver = (section, sliderEl) => {
    if (!section || !sliderEl || !sliderEl.swiper) return;

    const hasAutoplay = sliderEl.getAttribute("data-autoplay") === "true";

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (hasAutoplay) sliderEl.swiper.autoplay.resume();
          playVideo(sliderEl.swiper);
        } else {
          if (hasAutoplay) sliderEl.swiper.autoplay.pause();
          stopVideo(sliderEl.swiper);
        }
      });
    });

    sectionObserver.observe(section);
  };

  const initTaglineSlider = (section) => {
    const sliderEl = section.querySelector(".js-image-slider-tagline");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();

    const heightMode = sliderEl.dataset.heightMode || "fixed";

    const setFixedHeight = (swiper) => {
      let maxHeight = 0;

      swiper.slides.forEach((slide) => {
        const slideContent = slide.children[0];
        if (slideContent && slideContent.offsetHeight > maxHeight) {
          maxHeight = slideContent.offsetHeight;
        }
      });

      sliderEl.style.height = maxHeight + "px";
      swiper.slides.forEach((slide) => {
        slide.style.height = maxHeight + "px";
      });
    };

    const setAutoHeight = (swiper) => {
      const currentSlide = swiper.slides[swiper.activeIndex];
      const currentSlideContent = currentSlide.children[0];
      sliderEl.style.height = currentSlideContent.offsetHeight + "px";
    };

    new Swiper(sliderEl, {
      loop: true,
      slidesPerView: 1,
      direction: "vertical",
      autoHeight: false,
      speed: 800,
      allowTouchMove: false,
      on: {
        init: function (swiper) {
          if (heightMode === "fixed") {
            setFixedHeight(swiper);
          } else {
            setAutoHeight(swiper);
          }
        },
        slideChange: function (swiper) {
          if (heightMode === "auto") {
            setAutoHeight(swiper);
          }
        },
        resize: function (swiper) {
          if (heightMode === "fixed") {
            setFixedHeight(swiper);
          } else {
            setAutoHeight(swiper);
          }
        },
      },
    });
  };

  const initMediaSlider = (section) => {
    const sliderEl = section.querySelector(".js-image-slider-media");
    if (!sliderEl) return;

    if (sliderEl.swiper) sliderEl.swiper.destroy();

    const nextBtn = section.querySelector(".slider-nav-button--next");
    const prevBtn = section.querySelector(".slider-nav-button--prev");
    const paginationEl = section.querySelector(".slider-pagination");
    const sliderLoop = sliderEl.getAttribute("data-loop") === "true";
    const hasSliderAutoplay = sliderEl.getAttribute("data-autoplay") === "true";
    const pauseAutoplayOnHover =
      sliderEl.getAttribute("data-autoplay-pause-on-hover") === "true";
    const autoplayDelay = Number(sliderEl.dataset.autoplayDelay || 5000);
    const animationType = sliderEl.dataset?.animationType || "slide";

    const mediaSwiper = new Swiper(sliderEl, {
      loop: sliderLoop,
      slidesPerView: 1,
      spaceBetween: animationType === "slide" ? 12 : 0,
      speed: 800,
      watchSlideProgress: true,
      allowTouchMove: true,
      effect: animationType,
      creativeEffect:
        animationType === "creative"
          ? {
              prev: {
                translate: ["-20%", 0, -1],
              },
              next: {
                translate: ["100%", 0, 0],
              },
            }
          : {},
      resistanceRatio: animationType === "creative" ? 0 : 0.85,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: hasSliderAutoplay
        ? {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseAutoplayOnHover,
          }
        : false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "swiper-button-disabled",
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        576: {
          spaceBetween: animationType === "slide" ? 20 : 0,
        },
      },
      on: {
        autoplayTimeLeft(s, time, progress) {
          if (paginationEl) {
            paginationEl.style.setProperty("--slider-progress", 1 - progress);
          }
        },
        slideChangeTransitionStart() {
          this.allowSlideNext = false;
          this.allowSlidePrev = false;
          this.allowTouchMove = false;

          playVideo(this);
        },
        slideChangeTransitionEnd() {
          this.allowSlideNext = true;
          this.allowSlidePrev = true;
          this.allowTouchMove = true;
        },
      },
    });

    const taglineSlider = section.querySelector(".js-image-slider-tagline");

    if (taglineSlider?.swiper && mediaSwiper) {
      mediaSwiper.controller.control = taglineSlider.swiper;
    }

    initAutoplayObserver(section, sliderEl);
  };

  const parentSection = document.currentScript.parentElement;
  initTaglineSlider(parentSection);
  initMediaSlider(parentSection);

  document.addEventListener("shopify:section:load", function (event) {
    initTaglineSlider(event.target);
    initMediaSlider(event.target);
  });
})();
